export var RichTextFormat = /*#__PURE__*/function (RichTextFormat) {
  RichTextFormat["Adf"] = "adf";
  RichTextFormat["Wiki"] = "wiki";
  return RichTextFormat;
}({});